import isStrictObject from "../../common-utils/object/isStrictObject.util.js";
import isEmptyStrictObject from "../../common-utils/object/isEmptyStrictObject.util.js";
import isArray from "../../common-utils/array/isArray.util.js";
import isEmptyArray from "../../common-utils/array/isEmptyArray.util.js";
export const pickObjectUtil = (obj, objKeys) => isStrictObject(obj) && !isEmptyStrictObject(obj) && isArray(objKeys) && !isEmptyArray(objKeys)
    ? Object.keys(obj).reduce((acc, objKey) => !objKeys.includes(objKey) ? acc : { ...acc, [objKey]: obj[objKey] }, {})
    : obj;
export default pickObjectUtil;
